(function () {

    'use strict';
    angular.module('vobeApp')
        .component('cfTurnstile', {
            bindings: {
                siteKey: '@',
                onChallengeCompleted: '&'
            },
            controller: CfTurnstile,
            template: '<div id="turnstile-container"></div>',
        });

    function CfTurnstile($window, $document, $log) {
        'ngInject';
        var vm = this;
        var widgetId = null;

        vm.$onInit = function () {
            // Reset any existing widget and clear the container before rendering
            resetExistingWidget();

            function loadAndRenderTurnstile() {
                var containerId = 'turnstile-container';
                $window.onloadTurnstileCallback = function () {
                    // Remove any existing widget first
                    if (widgetId !== null && $window.turnstile) {
                        try {
                            $window.turnstile.remove(widgetId);
                        } catch (e) {
                            $log.debug('Could not remove existing turnstile widget');
                        }
                    }
                    widgetId = $window.turnstile.render('#' + containerId, {
                        sitekey: vm.siteKey,
                        callback: function (token) {
                            if (vm.onChallengeCompleted) {
                                vm.onChallengeCompleted({token: token});
                            }
                        },
                    });
                    // Store widget ID globally for reset access
                    $window.turnstileWidgetId = widgetId;
                };
            }

            loadAndRenderTurnstile();

            if (!$window.turnstileLoaded) {
                var script = $document[0].createElement('script');
                script.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?onload=onloadTurnstileCallback";
                script.defer = true;
                $document[0].body.appendChild(script);
                $window.turnstileLoaded = true;
            } else {
                // If script is already loaded, immediately initialize the widget
                $window.onloadTurnstileCallback();
            }
        };

        vm.$onDestroy = function () {
            // Clean up widget when component is destroyed
            if (widgetId !== null && $window.turnstile) {
                try {
                    $window.turnstile.remove(widgetId);
                    widgetId = null;
                    $window.turnstileWidgetId = null;
                } catch (e) {
                    $log.debug('Could not remove turnstile widget on destroy');
                }
            }
        };

        function resetExistingWidget() {
            // Reset any previously stored widget
            if (angular.isDefined($window.turnstileWidgetId) && $window.turnstileWidgetId !== null && $window.turnstile) {
                try {
                    $window.turnstile.reset($window.turnstileWidgetId);
                    $log.debug('Reset existing turnstile widget');
                } catch (e) {
                    $log.debug('Could not reset existing turnstile widget');
                }
            }
        }
    }

})();
